import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter,
} from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
  list2lpjhmv1d2k19 as list,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instancekqccuusv4qnz as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePlayerInput3s7vno6nbe1ix as SavePlayerInput } from '../SavePlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInput_InputAdapterClass;
function SavePlayerInput_InputAdapter() {
  if (SavePlayerInput_InputAdapterClass === VOID) {
    class $ {
      z3z(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      h6q(writer, customScalarAdapters, value) {
        writer.c48('partyId');
        get_partyIdAdapter().a40(writer, customScalarAdapters, value.x6o_1);
        writer.c48('playerId');
        get_playerIdAdapter().a40(writer, customScalarAdapters, value.y6o_1);
        writer.c48('name');
        get_StringAdapter().a40(writer, customScalarAdapters, value.z6o_1);
        writer.c48('email');
        get_StringAdapter().a40(writer, customScalarAdapters, value.a6p_1);
        writer.c48('badge');
        Badge_ResponseAdapter_instance.j6k(writer, customScalarAdapters, value.b6p_1);
        writer.c48('callSignAdjective');
        get_StringAdapter().a40(writer, customScalarAdapters, value.c6p_1);
        writer.c48('callSignNoun');
        get_StringAdapter().a40(writer, customScalarAdapters, value.d6p_1);
        var tmp = value.e6p_1;
        if (tmp instanceof Present()) {
          writer.c48('imageURL');
          present(get_NullableStringAdapter()).j41(writer, customScalarAdapters, value.e6p_1);
        }
        var tmp_0 = value.f6p_1;
        if (tmp_0 instanceof Present()) {
          writer.c48('avatarType');
          present(get_NullableStringAdapter()).j41(writer, customScalarAdapters, value.f6p_1);
        }
        writer.c48('unvalidatedEmails');
        list(get_StringAdapter()).h41(writer, customScalarAdapters, value.g6p_1);
      }
      a40(writer, customScalarAdapters, value) {
        return this.h6q(writer, customScalarAdapters, value instanceof SavePlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePlayerInput_InputAdapterClass = $;
  }
  return SavePlayerInput_InputAdapterClass;
}
var SavePlayerInput_InputAdapter_instance;
function SavePlayerInput_InputAdapter_getInstance() {
  return SavePlayerInput_InputAdapter_instance;
}
//region block: init
SavePlayerInput_InputAdapter_instance = new (SavePlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePlayerInput_InputAdapter_instance as SavePlayerInput_InputAdapter_instancertyni6zcgh3z,
};
//endregion

//# sourceMappingURL=SavePlayerInput_InputAdapter.mjs.map
